import Vue from 'vue'
import App from './App.vue'
// import router  from './router/index'
// import ElementUI from 'element-ui';
// import ajax from './common/axios.config'
// import 'element-ui/lib/theme-chalk/index.css';
// import VueAudio from 'vue-audio-better'
// import store from './config/config'
// import {  Loading } from 'element-ui';
// import VideoPlayer from 'vue-video-player'
// import 'video.js/dist/video-js.css' //videoJs的样式
// import 'vue-video-player/src/custom-theme.css' //vue-video-player的样式

// import hevueImgPreview from './components/tools/hevue-img-preview'

// const echarts = require('echarts');

// Vue.use(VueAudio).use(VideoPlayer).use(hevueImgPreview,{ clickMaskCLose: true})

// Vue.use(ElementUI);

// Vue.prototype.$loading = Loading
// Vue.prototype.openLoading = function(target) {
// 	const loading = this.$loading.service({ // 声明一个loading对象
// 			lock: true, // 是否锁屏
// 			background: 'rgba(255, 255, 255, 0.7)', // 背景颜色
// 			target: target ? target : document.body, // 需要遮罩的区域
// 			body: true,
// 	})
// 	return loading;
// }
// Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
// Vue.prototype.ajax = ajax
// Vue.prototype.$store = store; // 将store实例挂在vue原型上

new Vue({
  render: h => h(App),
	// router,
	// store
}).$mount('#app')
